import { render, staticRenderFns } from "./FiltersList.vue?vue&type=template&id=61301540&scoped=true&"
import script from "./FiltersList.vue?vue&type=script&lang=js&"
export * from "./FiltersList.vue?vue&type=script&lang=js&"
import style0 from "./FiltersList.vue?vue&type=style&index=0&id=61301540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61301540",
  null
  
)

export default component.exports